import React, { FC, useEffect, useState } from "react";
import { ModalProps } from "../../../../helpers/constants";
import Modal from "../../../../components/common/form/Modal";
import ButtonTray from "../../../../components/common/form/ButtonTray";

interface SelectYearModalProps extends ModalProps {
    title: string;
    onSubmit?: (e: any, selectedYear: string) => void;
    isLoading?: boolean;
}

const SelectYearModal: FC<SelectYearModalProps> = ({
                                                       show,
                                                       setShow,
                                                       title = "",
                                                       onSubmit,
                                                       isLoading = false
                                                   }) => {
    const currentYear = new Date().getFullYear();
    const [yearList, setYearList] = useState<string[]>([]);
    const [selectedYear, setSelectedYear] = useState<string>("");

    useEffect(() => {
        const years = Array.from({ length: 10 }, (_, i) => (currentYear - i).toString());
        setYearList(years);
        setSelectedYear(currentYear.toString()); // Preselect current year
    }, []);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (onSubmit) {
            await onSubmit(e, selectedYear);
        }
        setShow(false);
    };

    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className={"w-2/6 bg-text-0 text-surface-0"}
            fields={
                <>
                    {/* Body Content */}
                    <div>
                        <h3 className="mb-5 text-base font-normal text-surface-0">
                            Please select a tax year associated with the import
                        </h3>

                        <select
                            className="w-full p-2 border border-surface-4 rounded-md text-surface-0 bg-text-0"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                        >
                            <option value="">-- Select Year --</option>
                            {yearList.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Footer with Buttons */}
                    <div className="mt-4 border-t border-t-surface-5 flex justify-end">
                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "cancel"
                                    },
                                    buttonType: "button"
                                },
                                {
                                    buttonProps: {
                                        btnText: "Submit",
                                        onClick: handleSubmit,
                                        type: "submit",
                                        isLoading: isLoading
                                    },
                                    buttonType: "button"
                                }
                            ]}
                            align={"end"}
                            gap={2}
                        />
                    </div>
                </>
            }
        />
    );
};

export default SelectYearModal;
